module.exports = __webpack_public_path__ + "media/images/workplace/intro-page/step2-1-8085fe6fee6efb90bc2353a27760dc8c.gif";